import { Component, Input, OnChanges } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ViewEmailModalComponent } from '../../shared/_components/view-email-modal/view-email-modal.component';
import { dateAsString } from '../../shared/date.helper';

@Component({
  selector: 'app-inspection-change',
  templateUrl: './inspection-change.component.html',
  styleUrls: ['./inspection-change.component.scss'],
})
export class InspectionChangeComponent implements OnChanges {
  @Input() changes: any[];

  ngOnChanges(changes) {
    if ('changes' in changes && this.changes) {
      this.changes.forEach(change => {
        for (const key in change.changes) {
          change.changes[key].type = this.getType(key, change.changes[key]);
          change.changes[key] = this.clean(key, change.changes[key]);
        }
      });
    }
  }

  getType(key, item) {
    // console.log('item', item)

    if (key === 'EMAIL_SENT' || key === 'Rec_EMAIL_SENT' || key === 'note') {
      return key;
    }
    return 'generic';
  }

  clean(key, item) {
    if (['dueDate'].includes(key)) {
      const before = new Date(item.before);
      const after = new Date(item.after);
      item.before = isNaN(before.getTime()) ? item.before : dateAsString(item.before);
      item.after = isNaN(after.getTime()) ? item.after : dateAsString(item.after);
    }

    if (
      [
        'lastSynced',
        'completed',
        'rejected',
        'resubmitted',
        'accepted',
        'paid',
        'underwrintingClosed',
        'automatedDueDateNotificationSent',
      ].includes(key)
    ) {
      const before = new Date(item.before);
      const after = new Date(item.after);
      item.before = isNaN(before.getTime())
        ? item.before
        : before.toLocaleDateString('en-us', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          });
      item.after = isNaN(after.getTime())
        ? item.after
        : after.toLocaleDateString('en-us', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          });
    }

    if (['inspector', 'vendor'].includes(key)) {
      item.before = item.before.replace(' - undefined undefined', '');
      item.after = item.after.replace(' - undefined undefined', '');
    }

    if ('before' in item && item.before !== false && !item.before) {
      item.before = '-';
    }

    return item;
  }

  dateAsString = date => {
    return new Date(date).toLocaleDateString('en-us', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });
  };

  constructor(private modalService: BsModalService) {}

  // Handles edge cases/legacy
  hasUser(change) {
    return change?.username?.indexOf('undefined') === -1;
  }
  previewEmail(id: number) {
    this.modalService.show(ViewEmailModalComponent, {
      class: 'modal-lg',
      initialState: {
        id: id,
      },
    });
  }
}
